import { render, staticRenderFns } from "./ship-button.vue?vue&type=template&id=ed428172"
import script from "./ship-button.vue?vue&type=script&lang=js"
export * from "./ship-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports